import colors from '@loggi/ui/components/utils/colors';
import icons from '@loggi/ui/components/utils/icons';

const STATUS_LAYOUT_TYPES = {
  ADDRESS_WITHOUT_COMPLEMENT: 'WARNING_LAYOUT',
  DAMAGED_PACKAGE: 'WARNING_LAYOUT',
  DELAYED_DELIVERY: 'WARNING_LAYOUT',
  DELAYED_DELIVERY_WITH_NEW_DATE: 'WARNING_LAYOUT',
  DELIVERY_DENIED: 'WARNING_LAYOUT',
  FALLBACK_STATUS: 'WARNING_LAYOUT',
  INVALID_PACKAGE_DIMENSIONS: 'WARNING_LAYOUT',
  LOST_PACKAGE: 'WARNING_LAYOUT',
  PACKAGE_NOT_FOUND: 'WARNING_LAYOUT',
  STOLEN_PACKAGE: 'WARNING_LAYOUT',
  SUSPENDED_PACKAGE: 'WARNING_LAYOUT',
  UNAVAILABLE_CANCELED: 'WARNING_LAYOUT',
  UNAVAILABLE_RECIPIENT: 'WARNING_LAYOUT',
  UNAVAILABLE_RECIPIENT_WITH_NEW_DATE: 'WARNING_LAYOUT',
  WAITING_DEVOLUTION: 'WARNING_LAYOUT',
  WRONG_ADDRESS: 'WARNING_LAYOUT',
  RECIPIENT_PICKUP: 'WARNING_LAYOUT',
  GOING_TO_RECIPIENT: 'ACTIVE_LAYOUT',
  GOING_TO_RECIPIENT_WITH_RELATIVE_ETA: 'ACTIVE_LAYOUT',
  IN_LOGGI: 'ACTIVE_LAYOUT',
  IN_SENDER: 'ACTIVE_LAYOUT',
  IN_RECIPIENT: 'SUCCESS_LAYOUT'
};

const STATUS_DISPLAY_INFO_LABEL = {
  newDeliveryDate: 'Nova data de entrega',
  forecastDate: 'Entrega prevista para',
  deliveryDone: 'Entrega concluída',
  trackingKey: 'Código de rastreamento'
};

const {
  newDeliveryDate,
  forecastDate,
  deliveryDone,
  trackingKey
} = STATUS_DISPLAY_INFO_LABEL;

const STATUS_LAYOUT = {
  WARNING_LAYOUT: {
    forecastDisplayInfoLabel: newDeliveryDate,
    markerIcon: icons.type.WRONG
  },
  ACTIVE_LAYOUT: {
    forecastDisplayInfoLabel: forecastDate,
    markerIcon: icons.type.HOME
  },
  SUCCESS_LAYOUT: {
    forecastDisplayInfoLabel: deliveryDone,
    markerIcon: icons.type.CHECK
  }
};

export default function getLayout(status) {
  const statusLayoutType = STATUS_LAYOUT_TYPES[status];
  const layout = STATUS_LAYOUT[statusLayoutType];

  return {
    color: colors.type.ACTIVE,
    textColor: colors.type.WHITE,
    styleName: 'neutral',
    pkKeyDisplayInfoLabel: trackingKey,
    forecastDisplayInfoLabel: layout.forecastDisplayInfoLabel,
    markerIcon: layout.markerIcon
  };
}
